<div class="container">
  <div
    class="description"
    [innerHtml]="
      variables?.length
        ? (recipe.template.description | variablePlaceholders: variables : true)
        : recipe.template.description
    "></div>
  <div class="actions">
    <pdq-slide-toggle (onToggle)="handleToggleClick($event)" [defaultValue]="recipe?.isActive"></pdq-slide-toggle>
    <pdq-button
      pdqPopover
      variant="ghost"
      icon="dots_menu"
      [forcePosition]="'bottom_right'"
      [popoverTemplate]="popoverTemplate"
      [popoverContent]="popoverContent"></pdq-button>
    <ng-template #popoverTemplate>
      <pdq-popover-container [loading]="false">
        <div class="action-list" #popoverContent>
          @for (action of recipeActions; track action) {
            <pdq-option
              (onSelect)="handleAction($event)"
              [optionId]="action.id"
              [variant]="action.destructive ? 'danger' : 'ghost'"
              >{{ action.label }}</pdq-option
            >
          }
        </div></pdq-popover-container
      >
    </ng-template>
  </div>
</div>
